import s from "../product.module.css";


const ProductTabCharacters = () => {
    return (
        <div className={s.tabCharacters}>
            <ul>
                <li>Материал: <span>Бязь-ранфорс</span></li>
                <li>Плотность: <span>135 гр/м2</span></li>
                <li>Размер: <span>Полуторный, Двуспальный, Евро, Семейный</span></li>
                <li>Состав ткани: <span>100% хлопок</span></li>
                <li>Страна производитель: <span>Украина</span></li>
            </ul>
        </div>
    )
}

export default ProductTabCharacters;